<template>
  <div class="content">
    <div class="page-inner">
      <h1 class="mb-4 fw-thin">
        SmartLink Editor
      </h1>

      <div class="bg-white">
        <div class="card-body p-2">
          <div class="form-group mb-3">
            <h2 class="fw-thin">
              Release
            </h2>
            <h3 class="fw-thin text-primary">
              <span v-if="!loading">
                {{ smartlink.artist.name }} - {{ smartlink.distribution.title }}
              </span>
              <i class="fa fa-spinner fa-spin text-muted" v-if="loading"></i>
            </h3>
            <a :href="`https://indfy.me/${smartlink.key}`" class="btn btn-block btn-gradient mt-3 text-white" target="_blank">
              {{ $t('open_smartlink') }}
            </a>
            <button class="btn btn-block btn-gray mt-2" @click="copyLink()">
              {{ $t('copy_link') }}
            </button>
          </div>
        </div>
      </div>

      <div class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100 bg-white">
        <a  href="javascript:void(0)" class="nav-link" :class="{ 'active': tab === 'editor' }" @click="tab = 'editor'">
          Editor
        </a>
        <a  href="javascript:void(0)" class="nav-link" :class="{ 'active': tab === 'analytics' }" @click="gotoAnalytics()">
          Analytics <span class="badge badge-primary ml-1">PRO</span>
        </a>
      </div>

      <div class="bg-white pt-3" v-show="tab === 'editor'">
        <div class="card-body p-2 pb-4">
          <h2 class="fw-thin mt-2">
            Store List
          </h2>
          <ul class="list-group list-group-lg list-group-bordered mt-3 store-list">
            <draggable v-model="smartlink.stores" group="people" @start="drag=true" @end="drag=false" @update="onUpdateOrder()">
              <li class="list-group-item d-block" v-for="store in smartlink.stores" :key="store._id">
                <i class="fa fa-arrows-alt mt-1 mr-3"></i>
                <span>{{ store.name }}</span>
                <div class="pull-right mt--1" @click="toggleStore(store)">
                  <input :checked="store.active" type="checkbox" :disabled="!user.subscription" :data-store="store.name" data-toggle="toggle" data-onstyle="primary" data-style="btn-round" class="toggle-checkbox dsp-checkbox pull-right" data-size="small"/>
                </div>
              </li>
            </draggable>
          </ul>
        </div>
      </div>

      <div class="bg-white pt-3" v-show="tab === 'analytics'">
        <div class="card-body p-0 pb-4">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>
                    Views
                  </th>
                  <th>
                    Clicks
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ getViews() }}
                  </td>
                  <td>
                    {{ getClicks() }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import draggable from 'vuedraggable'
import Smartlinks from '../services/smartlinks'

export default {
  name: 'Smartlinks',
  data: function () {
    return {
      loading: false,
      tab: 'editor',
      activity: [],
      smartlink: {
        artist: {},
        distribution: {},
        stores: []
      },
      user: {}
    }
  },
  methods: {
    copyLink: function () {
      const el = document.createElement('textarea')
      el.value = `https://indfy.me/${this.smartlink.key}`
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$notify({ message: this.$t('something_copied').replace('<br>', 'Link') }, 'success', 'fa-check')
    },
    gotoAnalytics: function () {
      if (!this.user.subscription) {
        return this.$router.push(`/upgrade`)
      }

      this.tab = 'analytics'
    },
    getViews: function () {
      return _.filter(this.activity, item => item.action === 'open').length
    },
    getClicks: function () {
      return _.filter(this.activity, item => item.action === 'click').length
    },
    getActivity: function () {
      Smartlinks.getActivity(this.$route.params.id).then(response => {
        this.activity = response.data
      })
    },
    save: function () {
      if (!this.user.subscription) {
        return
      }

      Smartlinks.save(this.smartlink).then(response => {
        console.log('Updated')
      })
    },
    onUpdateOrder: function () {
      if (!this.user.subscription) {
        return this.$router.push(`/upgrade`)
      }

      this.updateSwitchValues()
      this.save()
    },
    getSmartlink: function () {
      Smartlinks.get(this.$route.params.id).then(response => {
        this.smartlink = response.data
        this.loading = false

        setTimeout(() => {
          this.initCheckboxes()
        }, 1)
      })

      this.getActivity()
    },
    updateSwitchValues: function () {
      _.each(this.smartlink.stores, store => {
        window.$(`[data-store="${store.name}"]`).prop('checked', store.active).change()
      })
    },
    toggleStore: function (store) {
      if (!this.user.subscription) {
        return this.$router.push(`/upgrade`)
      }

      store.active = !store.active

      setTimeout(() => {
        window.$(`[data-store="${store.name}"]`).prop('checked', store.active).change()
      }, 1)

      this.save()
    },
    initCheckboxes: function () {
      window.$('.toggle-checkbox[data-toggle]').bootstrapToggle()
    }
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true

      window.$('html, body').animate({
        scrollTop: 0
      }, 500)
    }, 100)
  },
  created: function () {
    this.user = this.$user
    this.getSmartlink()

    window.document.title = this.$t('services_title') + ' | Indiefy'
    window.$('meta[name="description"]').attr('content', this.$t('services_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('services_description'))
  },
  components: {
    draggable
  }
}
</script>
<style lang="scss" scoped>
.store-list {
  .fa-arrows-alt {
    cursor: move;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SmartlinkEditor.vue